import * as React from 'react';
import styles from './AgentPanel.styles';
import AgentFreeform from './AgentFreeform';
import { AgentActionGroups } from './AgentActionGroups';
import { AgentPanelProps } from './AgentPanel.container';


interface AgentPanelState {
  currentTab: number;
}

export class AgentPanel extends React.Component<AgentPanelProps, AgentPanelState> {
  state: AgentPanelState = {
    currentTab: 0,
  };

  constructor(props: AgentPanelProps) {
    super(props);
  }

  onSelectTab = (tab: number) => {
    this.setState({
      currentTab: tab,
    });
  };

  render() {
    const { currentTab } = this.state;
    const { agentConfig, conversations, addChat, scope } = this.props;
    const tabs = ['Built In Actions', 'Ask AI Anything'];
    const actionGroups = agentConfig?.actions?.view || [];

    return (
      <div className={styles.AgentPanelView}>
        <div className="tabs" data-qa="agent-tab-container">
          {tabs.map((tabName, index) => {
            const classes = 'tab' + (index === currentTab ? ' selected' : '');
            return (
              <div
                key={`tab_${index}`}
                className={classes}
                onClick={() => this.onSelectTab(index)}
                data-selected={index === currentTab ? '1' : '0'}
                data-qa="agent-tab"
              >
                <span className="tab-text">{tabName}</span>
              </div>
            );
          })}
        </div>
        <div className="tab-content" data-qa="agent-tab-content">
          {currentTab === 0 && (
            <div className="content-panel">
              <AgentActionGroups actionGroups={actionGroups} scope={scope} />
            </div>
          )}
          {currentTab === 1 && (
            <div className="content-panel">
              <AgentFreeform conversations={conversations} onSendMessage={addChat} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AgentPanel;
